// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/heading-chain.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/heading-chain/heading-chain.js';
import g1 from '../lessons/navigation/heading-chain/variation-deviation.js';

mount([g0, g1]);
